module.exports = __webpack_public_path__ + "static/img/g10.e2624c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/g10.svg
// module id = 84UC
// module chunks = 0